import React, { useState } from 'react';
import { api } from '../../shared/api';

export function WebhookTestButton({ config }) {
  const [testing, setTesting] = useState(false);
  const [result, setResult] = useState(null);

  const runTest = async () => {
    setTesting(true);
    setResult(null);
    try {
      const res = await api.post('/elevenlabs/test-webhook', {
        url: config.url,
        method: config.method || 'POST',
        auth_type: config.auth_type || 'none',
        auth_value: config.auth_value || '',
      });
      setResult(res);
    } catch (e) {
      setResult({ success: false, steps: [{ step: 'Verbindung', status: 'error', detail: String(e) }] });
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="mt-1">
      <button
        onClick={runTest}
        disabled={testing}
        className="w-full px-4 py-2.5 bg-gray-800 text-white text-sm font-medium rounded-lg hover:bg-gray-700 disabled:opacity-50 transition-colors"
        data-testid="test-webhook-btn"
      >
        {testing ? 'Teste Verbindung...' : 'Webhook testen'}
      </button>
      {result && (
        <div className={`mt-3 p-3 rounded-lg text-sm space-y-2 ${result.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
          <p className={`font-medium ${result.success ? 'text-green-700' : 'text-red-700'}`}>
            {result.success ? 'Webhook erreichbar!' : 'Probleme gefunden:'}
          </p>
          {(result.steps || []).map((s, i) => (
            <div key={i} className="flex items-start gap-2 text-xs">
              <span className="flex-shrink-0 mt-0.5">
                {s.status === 'ok' ? '\u2705' : s.status === 'warning' ? '\u26A0\uFE0F' : '\u274C'}
              </span>
              <div>
                <span className="font-medium">{s.step}:</span>{' '}
                <span className={s.status === 'error' ? 'text-red-600' : 'text-gray-600'}>{s.detail}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
